import { DateRange } from '../../models/date-range/date-range.model';
import { parseIsoWeekToInterval } from '../parse-iso-week-to-interval/parse-iso-week-to-interval.function';

/**
 * @name parseIsoWeekToDateRange
 * @category Common Helpers
 * @summary Parse ISO 8601 week notation to date-fns interval
 *
 * @description
 * Parse the given string in ISO 8601 week notation format (YYYY-Www) and return an Interval object.
 *
 * @param notation - ISO 8601 week notation string (e.g., '2026-W04')
 * @returns interval object representing the start and end of the ISO week
 *
 * @example
 * // Convert string '2026-W04' to interval:
 * const result = parseIsoWeekToInterval('2026-W04')
 * //=>
 * {
 *   start: Mon Jan 19 2026 00:00:00 ...,
 *   end: Sun Jan 25 2026 23:59:59 ...
 * }
 */
export function parseIsoWeekToDateRange(notation: string): DateRange {
  const interval = parseIsoWeekToInterval(notation);
  return new DateRange(interval.start, interval.end, true, true);
}
